import { render } from "./TeamManageView.vue?vue&type=template&id=2446f9fc"
import script from "./TeamManageView.vue?vue&type=script&lang=js"
export * from "./TeamManageView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__